import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { Course } from 'src/app/shared/models/course.model';
import { User } from 'src/app/shared/models/user.model';
import { CourseService } from 'src/app/shared/services/course.service';
import { DashboardService } from 'src/app/shared/services/dashboard.service';
// import { DashboardService } from 'src/app/services/dashboard.service';
// import { CourseService } from 'src/app/services/course.service';
// import { config } from 'src/app/config';
// import { User } from 'src/app/models/user.model';
// import { Router } from '@angular/router';
// import { Course } from 'src/app/models/course.model';
// declare var amplitude;
declare var _gscq;
declare var mixpanel;

@Component({
  selector: 'app-course-completed',
  templateUrl: './course-completed.component.html',
  styleUrls: ['./course-completed.component.css']
})
export class CourseCompletedComponent implements OnInit {

  @Input()
  config: {
    courseTitle: string,
    courseTrait: string
    courseId: string,
    surveyId: string
    courseTemplate: string,
    isGenerateCompletionCertificate: boolean
  };
  inCompleteExercises: {
    id: string
    title: string
    moduleNumber: number
    moduleName: string
    sequenceNumber: number
  }[]
  inCompleteContents: {
    id: string
    title: string
    moduleNumber: number
    moduleName: string
    sequenceNumber: number
  }[]
  
  totalPercentage: number = 0;
  totalPoints: number = 0;
  progress: number = 0;
  isLoaded:boolean=false;
  @Output() viewedCertificate = new EventEmitter<string>();
  @Output() skipModuleEnd: EventEmitter<boolean> = new EventEmitter<boolean>(false);
  pendingScores: boolean = false;
  gridResult:any={
    SKILL:'HIGH',
    EFFORT:'MEDIUM',
    CONFIDENCE:'LOW'
  }
  rows:any[]=[{level:'HIGH'},{level:'MEDIUM'},{level:'LOW'}]
  cells:any[]=[{parameter:'SKILL'},{parameter:'EFFORT'},{parameter:'CONFIDENCE'}]
  @Input() user: User;
  @Input() evaluationResult: any;
  @Input() currentUserCourse: any;
  recommendedCourses: Course[] = []
  emojiReactions={
    'HIGH':'assets/images/emoticon-laugh.svg',
    'MEDIUM':'assets/images/emoticon-smile.svg',
    'LOW':'assets/images/emoticon-sad.svg'
    }
  constructor(private router: Router, private dashboardService: DashboardService, private courseService: CourseService) { }
  ngOnInit(): void {
    this.getRecommendedCourses();
   
    this.dashboardService.courseCompleted(this.config.courseId,this.currentUserCourse.programActivationId).subscribe(res => {
      if (res) {
        res.contents && (this.inCompleteContents = Object.values(res.contents));
        res.exercises && (this.inCompleteExercises = Object.values(res.exercises));
        this.progress = this.currentUserCourse.progress;
        if (this.currentUserCourse) {
          this.pendingScores = this.currentUserCourse.exercises.some(el => el.status != 'PUBLISHED' && el['assessmentType'] == 'TA_GRADED');
          this.amplitudeCourseCompletionEvent();
        }
        if (!this.inCompleteExercises.length) {
         this.getEvaluationData();
        }else{
          this.isLoaded = true;
        }
      }
    });
  }

  getEvaluationData(){
    // commneted not being used in IPJ
    // this.courseService.evaluateCourse(this.config.courseId).subscribe(result => {
    //   if (result && result.courseProgress) {
    //     this.isLoaded = true;
    //     this.evaluationResult = result.courseProgress;
    //     this.totalPercentage = this.evaluationResult.totalPercentage;
    //     this.totalPoints=0;
    //   for (let k in result.marks.marksByExercise){

    //     this.totalPoints+=Math.round(result.marks.marksByExercise[k].gainedMarks)
    //   }        
    //     if(this.evaluationResult.isNewEvaluation){
    //       this.gridResult['SKILL'] = this.evaluationResult.skillLevel 
    //       this.gridResult['EFFORT'] = this.evaluationResult.effortLevel 
    //       this.gridResult['CONFIDENCE'] = this.evaluationResult.confidenceLevel 
    //     }
    //   }
    // });
  }

  openCertificate() {
    if (this.currentUserCourse.certificateInfo && this.currentUserCourse.certificateInfo.certificateId) {
      this.viewedCertificate.emit(`/accomplishments/${this.currentUserCourse.certificateInfo.certificateId}`);
    }
    else {
      this.courseService.generateCertificate(this.config.courseId).subscribe(res => {
        if (res) {
          this.viewedCertificate.emit(`/accomplishments/${this.currentUserCourse.certificateInfo.certificateId}`);
        }
      });
    }
    this.amplitudeCertificateOpen();
   }

  amplitudeCertificateOpen() {
    /* amplitude.getInstance().init(config.AMPLITUDE_API_KEY);
    amplitude.getInstance().setUserId(this.user.email);
    amplitude.getInstance().setUserProperties({ 'name': this.user.name, 'organization': this.user.organization, 'cohortName': (this.user['userGroup'] || '') });
    amplitude.getInstance().logEvent('Course Completion', { 'Course Name': this.config.courseTitle, 'Course Score': this.totalPercentage }); */

  }

  amplitudeCourseCompletionEvent() {
    /* amplitude.getInstance().init(config.AMPLITUDE_API_KEY);
    amplitude.getInstance().setUserId(this.user.email);
    amplitude.getInstance().setUserProperties({ 'name': this.user.name, 'organization': this.user.organization, 'cohortName': (this.user['userGroup'] || '') });
    amplitude.getInstance().logEvent('View Certificate', { 'Course Name': this.config.courseTitle }); */
    /* mixpanel.track('View Certificate', {
      'Course Name': this.config.courseTitle,
      'Page Title': 'document.title'
    }); */
  }

  getRecommendedCourses() {
    this.dashboardService.getRecommendedCourses().subscribe(res => {
      if (res) {
        this.recommendedCourses = res;
      }
    })
  }

  goToCourse(title) {
    this.router.navigate(['/courses/' + title.trim().split(' ').join('-').toLowerCase()]);
  }
  navigateToExercise(id) {
    this.skipModuleEnd.emit(true);
    this.courseService.setcurrentPlayedItem(id);
  }

}
